import { faTag } from "@jewlr/pro-regular-svg-icons/faTag"
import { useMemo } from "react"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"

const PriceBadge = () => {
  const { pricing, priorityBadge, wizardLoading } = useSelector((state) => ({
    // holidayDelivery: state.wizard.shipping?.main?.available_holiday_delivery,
    pricing: state.wizard.price_and_promo,
    priorityBadge: state.wizard.priorityBadge,
    wizardLoading: state.wizard.loading,
  }))

  const badgeContent = useMemo(() => {
    if (priorityBadge) {
      return (
        <>
          <FontAwesomeIcon
            className="text-8 tablet:text-16 mr-6 text-white"
            icon={faTag}
          />
          {priorityBadge.label}
        </>
      )
    }

    // if (holidayDelivery) {
    //   return `${sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday} Delivery`
    // }

    if (pricing.on_sale) {
      const percentageSavings = (
        ((pricing.regular_pricing - pricing.price_to_display) * 100) /
        pricing.regular_pricing
      ).toFixed(0)

      return `${percentageSavings}% Off`
    }

    return null
  }, [priorityBadge, pricing])
  // }, [priorityBadge, pricing, holidayDelivery])

  if (wizardLoading || !Object.keys(pricing).length || !badgeContent) {
    return null
  }

  return (
    <span className="body-sm text-primary border-primary h-26 inline-flex items-center justify-center rounded-full border px-6 font-semibold uppercase">
      {badgeContent}
    </span>
  )
}

export default PriceBadge
